import { useLingui } from '@lingui/react/macro';
import { Command, useCommandState } from '@utima/ui';
import type { ReactNode } from 'react';

export type ComboboxGroupProps = {
  totalCount: number;
  children: ReactNode;
};

/**
 * We need to create a custom group component to be able to
 * subscribe to command store using useCommandState hook.
 *
 * This component will be used to group the combobox options
 * and display the current count of the filtered items.
 */
export function ComboboxGroup({ children, totalCount }: ComboboxGroupProps) {
  const { t } = useLingui();
  const count = useCommandState(state => state.filtered.count);

  // Calculate the heading based on the current count
  const groupHeading = t`Showing ${totalCount} items, ${
    count > totalCount ? totalCount : count
  } of them are shown`;

  return <Command.Group heading={groupHeading}>{children} </Command.Group>;
}
